module.exports = __webpack_public_path__ + "img/dropsLive_600.e4c348d9.png";